'use client'

import { useEffect } from 'react'

import { FormSubscribe } from '@/lib/hubspot-integration/FormSubscribe.component'

import { Logo } from './ui/Logo'

export const SectionSubscribe = ({ isBlog = false }: { isBlog?: boolean }) => {
  useEffect(() => {
    const scrollToAnchor = () => {
      const element = document.getElementById('newsletter')

      if (element) {
        const scrollWithRetry = (retries = 3) => {
          const { top } = element.getBoundingClientRect()

          if (Math.abs(top) > 1 && retries > 0) {
            setTimeout(() => {
              element.scrollIntoView({ behavior: 'smooth', block: 'start' })
              scrollWithRetry(retries - 1)
            }, 100)
          }
        }

        element.scrollIntoView({ behavior: 'smooth', block: 'start' })

        scrollWithRetry()

        const observer = new MutationObserver(() => {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })

        observer.observe(document.body, { childList: true, subtree: true })

        setTimeout(() => observer.disconnect(), 3000)
      }
    }

    const handleHashChange = (event: Event) => {
      if (window.location.hash === '#newsletter') {
        event.preventDefault()
        scrollToAnchor()
      }
    }

    const handlePageLoad = () => {
      if (window.location.hash === '#newsletter') {
        scrollToAnchor()
      }
    }

    window.addEventListener('hashchange', handleHashChange)
    window.addEventListener('load', handlePageLoad)

    return () => {
      window.removeEventListener('hashchange', handleHashChange)
      window.removeEventListener('load', handlePageLoad)
    }
  }, [])

  return (
    <section
      id="newsletter"
      className="relative border-b border-gray-transparent-1000 px-6 pb-12 pt-16 xl:px-10 xl:pb-20 xl:pt-24"
    >
      <div
        className={`flex flex-col ${isBlog ? 'xl:flex-column' : 'xl:flex-row'}`}
      >
        <div className="flex-1 pb-10">
          <Logo />
        </div>
        <div className="desktop:pb-10 flex-1">
          <h2 className="heading-xl pb-10 pr-6 xl:pb-6 xl:pr-10">
            Join Our Journey
          </h2>
          <p className="paragraph-l pb-10 xl:pb-12">
            Get access to the latest news, announcements, upcoming events,
            <br className="hidden 2xl:table" /> and information about Cardano
            and the Cardano Foundation.
          </p>
          <FormSubscribe />
        </div>
      </div>
    </section>
  )
}
